import { render, staticRenderFns } from "./playlist-info.vue?vue&type=template&id=06078492&scoped=true"
import script from "./playlist-info.vue?vue&type=script&setup=true&lang=js"
export * from "./playlist-info.vue?vue&type=script&setup=true&lang=js"
import style0 from "./playlist-info.vue?vue&type=style&index=0&id=06078492&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06078492",
  null
  
)

export default component.exports